import { runSafe } from "../utils";
import { popupManager } from "./popups/PopupManager";
import { popupSelector } from "./popups/popup-config";
import { popupStorage } from "./popups/popup-storage";

export function initPopups(element: Element): void {
    runSafe(() => popupManager.init(element));
}

export function initPopup(popup: HTMLElement): void {
    popupManager.register(popup);
}

export function showPopup(popup: HTMLElement): void {
    popupManager.register(popup).show();
}

export function closePopup(popup: HTMLElement): void {
    popupManager.register(popup).close();
}

export function showPopupById(popupId: string): void {
    popupManager.getById(popupId)?.show();
}

export function getPopupById(popupId: string): HTMLElement | null {
    return document.querySelector<HTMLElement>(popupSelector(popupId));
}

export function setPopupDataToLocalStorage(popup: HTMLElement): void {
    popupManager.register(popup).markHidden();
}

export function preventPopupShowingById(popupId: string): void {
    popupStorage.markHidden(popupId);
}